/**
 * Check for ARKit support
 * Updated to enable AR for Chrome on phones and AR for Safari on tablets.
 * AR doesn't work for Chrome and we disabled it. Read more at : https://github.com/google/model-viewer/issues/2263
 *
 * This maybe fixed now and needs some investigation
 * https://github.com/google/model-viewer/issues/2449
 */
import Bowser from "bowser";

const { relList } = document.createElement("a");

const isBrowserCompatibleForAR = () => {
  return Bowser.name === "Chrome" || Bowser.name === "Safari";
};

const isIOS11Plus = () => {
  if (Bowser.osname !== "iOS") return false;
  const majorVersion = parseInt(Bowser.osversion.split(".")[0], 10);
  return majorVersion >= 11;
};

let arKitIsSupported = false;

try {
  const hasArTokenSupport =
    relList && relList.supports && relList.supports("ar");
  arKitIsSupported =
    isBrowserCompatibleForAR() && (hasArTokenSupport || isIOS11Plus());
  // eslint-disable-next-line no-empty
} catch (e) {}

export default () => arKitIsSupported;
